import { FC } from 'react';

interface Props {
  name: string;
  founded: string;
  stadium: string;
}

const TeamDetails: FC<Props> = ({ name, founded, stadium }) => {
  return (
    <div className='team-profile-container flex items-center flex-wrap text-4 text-secondaryMainEventParticipantNameColor gap-2 sm:gap-7'>
      <span className='team-country'>{name}</span>
      <span className='team-foundation'>{founded}</span>
      <span className='team-stadium'>{stadium}</span>
    </div>
  );
};

export default TeamDetails;
